const initialState = {
    
    states: {
      //showGiftCouponOnlinePayment : false
    },
  }
  
  const payment = (state = initialState, action) => {
    switch (action.type) {
  
      case 'SET_PAYMENT_REQUEST_LIST':
        return {
          ...state,
          paymentReqList: action.paymentList.userTransactionList,
          paymentReqListSuccess: action.paymentList.success,
          showPaymentView : true,
          verifySuccess:false,
          userPaySuccess : false,
          resCheckPalPalPaymentStatus : false,
          showPaypalPaymentProcess: false,
        }
        
      case 'SET_PAYMENT_BY_USER_DATA':
        return{
          ...state,
          showPaypalPaymentProcess: true,
          userTransactionData : action.data.transactionData,
          userTransactionSuccess : action.data.success,
          showPaymentView : false,
          verifySuccess:false,
          userPaySuccess : false,
          resCheckPalPalPaymentStatus : false
        }
       
      case 'SET_VERIYFY_SUCCESS_RESPONSE':
        return{
          ...state,
          showPaypalPaymentProcess: true,
          showPaymentView : false,
          rejectSuccess : false,
          rejectmessage: false,
          verifySuccess : action.response.success,
          verifymessage : action.response.message,
          userPaySuccess : false,
          resCheckPalPalPaymentStatus : false
        }
        
      case 'SET_VERIYFY_FAIL_RESPONSE':
       return{
        ...state,
        showPaypalPaymentProcess: true,
        showPaymentView : false,
        rejectSuccess : false,
        rejectmessage: false,
        verifySuccess : action.response.success,
        verifymessage : action.response.error,
        userPaySuccess : false,
        resCheckPalPalPaymentStatus : false
       }

       case 'SET_REJECT_SUCCESS_RESPONSE':
        return{
          ...state,
          showPaypalPaymentProcess: true,
          showPaymentView : false,
          verifySuccess : false,
          verifymessage: false,
          rejectSuccess : action.response.success,
          rejectmessage : action.response.message,
          userPaySuccess : false,
          resCheckPalPalPaymentStatus : false
          
        }
        
      case 'SET_REJECT_FAIL_RESPONSE':
       return{
        ...state,
        showPaypalPaymentProcess: true,
        showPaymentView : false,
        verifySuccess : false,
        verifymessage: false,
        rejectSuccess : action.response.success,
        rejectmessage : action.response.error,
        userPaySuccess : false,
        resCheckPalPalPaymentStatus : false
       }

       case 'SET_RESPONSE_PAPAL_PAY_USER':
       return{
        ...state,
        showPaypalPaymentProcess: true,
        showPaymentView : false,
        verifySuccess : false,
        verifymessage: false,
        userPaySuccess : action.data.success,
        userPayData : action.data.payout,
        resCheckPalPalPaymentStatus : false
       }

       case 'STOP_SHOW_RESPONSE_MESG':
       return{
        ...state,
        showPaypalPaymentProcess: true,
        showPaymentView : false,
        verifySuccess : false,
        verifymessage: false,
        rejectSuccess : false,
        rejectmessage: false,
        resCheckPalPalPaymentStatus : false,
        resCheckPalPalPaymentData: false
       }

       case 'SET_PAYPAL_PAYMENT_TXN_CHECK':
       return{
         ...state,
         showPaypalPaymentProcess: true,
         resCheckPalPalPaymentStatus : action.data.success,
         resCheckPalPalPaymentData : action.data.payout,
         showPaymentView : false,
       }
       //gitcoupon ........
       case 'SET_GIFTCOUPON_PAYMENT_BY_USER_DATA':
       return{
         ...state,
        showPaypalPaymentProcess: false,
        showPaymentView:false,
        showGiftCouponOnlinePayment: true,
        userGiftcouponOnlineTransactionData : action.data.transactionData,
        userGiftcouponOnlineTransactionSuccess : action.data.success,
       }

       case 'SET_VERIYFY_SUCCESS_GIFTCOUPON_ONLINE_RESPONSE':
        return{
          ...state,
          showGiftCouponOnlinePayment: true,
          showPaypalPaymentProcess: false,
          showPaymentView : false,
          giftCouponRejectSuccess : false,
          giftCouponRejectmessage : false,
          giftCouponOnlineVerifySuccess : action.response.success,
          giftCouponOnlineVerifymessage : action.response.message,
          userPaySuccess : false,
          resCheckPalPalPaymentStatus : false
        }
        
      case 'SET_VERIYFY_FAIL_GIFTCOUPON_ONLINE_RESPONSE':
       return{
        ...state,
        showGiftCouponOnlinePayment: true,
        showPaypalPaymentProcess: false,
        showPaymentView : false,
        giftCouponRejectSuccess : false,
        giftCouponRejectmessage: false,
        giftCouponOnlineVerifySuccess : action.response.success,
        giftCouponOnlineVerifymessage : action.response.error,
        userPaySuccess : false,
        resCheckPalPalPaymentStatus : false
       }

       case 'SET_REJECT_GIFTCOUPON_ONLINE_SUCCESS_RESPONSE':
        return{
          ...state,
          showGiftCouponOnlinePayment: true,
          showPaypalPaymentProcess: false,
          showPaymentView : false,
          giftCouponOnlineVerifySuccess : false,
          giftCouponOnlineVerifymessage: false,
          giftCouponRejectSuccess : action.response.success,
          giftCouponRejectmessage : action.response.message,
          userPaySuccess : false,
          resCheckPalPalPaymentStatus : false
          
        }
        
      case 'SET_REJECT_GIFTCOUPON_ONLINE_FAIL_RESPONSE':
       return{
        ...state,
        showGiftCouponOnlinePayment: true,
        showPaypalPaymentProcess: false,
        showPaymentView : false,
        giftCouponOnlineVerifySuccess : false,
        giftCouponOnlineVerifymessage: false,
        giftCouponRejectSuccess : action.response.success,
        giftCouponRejectmessage : action.response.error,
        userPaySuccess : false,
        resCheckPalPalPaymentStatus : false
      }

      case 'STOP_GIFTCOUPON_ONLINE_RESPONSE_MESG':
        return{
        ...state,
        showGiftCouponOnlinePayment: true,
        giftCouponOnlineVerifySuccess : false,
        giftCouponOnlineVerifymessage: false,
        giftCouponRejectSuccess : false,
        giftCouponRejectmessage: false,
        }

      case 'SET_GIFTCOUPON_COUNT_DATA':
        return{
          ...state,
          showGiftCouponOnlinePayment: false,
          showGiftCouponCountPaymentView : true,
          giftcouponCountSuccess : action.response.success,
          giftcouponCountData : action.response
        }

      case 'SET_GIFTCOUPON_PAYMENT_RESPONSE':
        return{
          ...state,
          showGiftCouponCountPaymentView: true,
          giftcouponPaymentSuccess: action.response.success,
          giftcouponPaymentData : action.response
        }

      default:
        return state;
    }
  };
  export default payment;
  


// WEBPACK FOOTER //
// ./src/reducers/payment.js